// extracted by mini-css-extract-plugin
module.exports = {"footer":"footerCopy_footer__1UDHK","dark":"footerCopy_dark__2gFG3","light":"footerCopy_light__EDpG2","list":"footerCopy_list__P9AX1","text":"footerCopy_text__11Eoc"};